import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { WorkMenuEvent } from '../../../events/work-menu-event';
import { UIMenuModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-menu-item-bootstrap',
  templateUrl: './e5core-ui-work-menu-item-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-menu-item-bootstrap.component.css']
})
export class E5coreUiWorkMenuItemBootstrapComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() menuItem: UIMenuModel ;
  @Output() clickEvent = new EventEmitter<WorkMenuEvent>() ;

  constructor() { }

  ngOnInit() {
  }

  onClick($event, menuCode) {
    this.clickEvent.emit({$event: $event, menuCode: menuCode}) ;
  }

}
